export interface Clock {
    currentTime(): number
}

export class ClockImpl {
    currentTime(): number {
        return Date.now();
    }
}